<template>
  <div class>
    <mdb-container class="mt-5 content-area fb-auth mt-5">
      <h4
        class="d-flex justify-content-center"
        v-if="isLoading"
      >Checking your permissions.. Please wait.</h4>

      <div class="d-flex justify-content-center mt-5" v-if="isLoading">
        <div class="spinner-grow text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div class v-if="!isLoading">
        <div class="row">
          <div v-if="isError" class="col-12">
            <mdb-alert class="d-flex justify-content-center" color="danger">
              <b>Oh no,</b> it looks like you have not granted all required
              permissions. Please grant the following permissions:
            </mdb-alert>
            <ul class="list-unstyled list-permissions">
              <li v-for="permission in notGrantedPermissions" :key="permission">
                <span v-if="permission.permission === 'instagram_basic'">
                  Access profile and posts from the Instagram account connected
                  to your Page
                </span>
                <span v-if="permission.permission === 'instagram_manage_insights'">
                  Access insights for the Instagram account connected to your
                  Page
                </span>
              </li>
            </ul>

            <a
              :href="fbAuth.authUrlDto.authUrl"
              class="mt-3 btn btn-primary"
            >Restart the authentication</a>
          </div>
        </div>
      </div>

      <div v-if="!isLoading && firstTry && fbAuth != null">
        <p>By connecting your Instagram account with virallyze you will save 50% for each search with virallyze.</p>
        <a :href="fbAuthUrl" class="mt-3 btn btn-primary">Start the authentication</a>
      </div>
    </mdb-container>
  </div>
</template>

<script>
import { mdbContainer, mdbAlert } from "mdbvue";
export default {
  name: "App",
  components: {
    mdbContainer,
    mdbAlert
  },
  computed: {
    isLoading: function() {
      return this.$store.getters["ui/isLoading"];
    },
    firstTry: function() {
      let urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get("code");
      return code === null;
    },
    fbAuthUrl: function() {
      return this.$store.getters["fbAuthUrl"];
    }
  },
  methods: {},
  data() {
    return {
      code: 0,
      fbAuth: {},
      isError: false,
      notGrantedPermissions: []
    };
  },
  created: function() {
    let urlParams = new URLSearchParams(window.location.search);
    this.code = urlParams.get("code");
    if (this.code !== null) {
      this.$store
        .dispatch("checkFbAuth", this.code)
        .then(() => {
          if (this.fbAuth.code === 1001) {
            this.isError = true;
            this.notGrantedPermissions = this.fbAuth.notGrantedPermissions;
          } else {
            this.$store.dispatch("user/updateUser").then(() => {});
            this.$router.push({ path: "dashboard" });
          }
        })
        .catch(() => {});
    } else {
      this.$store.dispatch("getFbAuthUrl").then(() => {});
    }
  }
};
</script>
